import {
    borrarDefaultDropDownOptions,
    defaultHeaderDropDown,
    freezeGenericMessage,
    setShowCheckStatus,
} from "../../../common/dataTables/utils";

const dataTablePedimentosElement = document.getElementById(
    "dataTablePedimentos",
);

export const dataTablePedimentos = new DataTable(dataTablePedimentosElement, {
    columns: [
        {
            id: "pedimento_formato",
            name: "Pedimento",
            dropdown: true,
            sortable: true,
            width: 175,
            format: (value) => {
                if (value == null) {
                    return "";
                }

                const valueContent = value.split("-")[0] || "";
                const callback = `siimmex.descargas_dirigidas.onClickBtnMostrarInfoPedimento(
                    '${String(value.split("-")[1]).trim()}'
                )`;

                return `
                    <span title="${valueContent}">${valueContent}</span>
                    <i
                        class="fas fa-info text-muted float-right d-none pt-1"
                        data-toggle="modal"
                        data-target="#modal-info-pedimento"
                        onClick="${callback}"
                        style="cursor: pointer"
                        title="Información del pedimento"
                    ></i>
                `;
            },
        },
        {
            id: "clave_documento",
            name: "Clave",
            sortable: true,
            dropdown: true,
            width: 72,
            align: "center",
        },
        {
            id: "fecha",
            name: "Fecha",
            sortable: true,
            dropdown: true,
            width: 108,
        },
        {
            id: "item-selected",
            name: "",
            format: (value) => {
                if (value) {
                    return `<span data-item-selected='${value}'></span>`;
                }
                return "";
            },
        },
    ].map((item) => ({
        ...dataTableColumnCommonConfiguration,
        ...item,
    })),
    headerDropdown: defaultHeaderDropDown,
    inlineFilters: true,
    serialNoColumn: false,
    checkboxColumn: false,
    noDataMessage: "Sin pedimentos de exportación disponibles",
    freezeMessage: freezeGenericMessage,
});

borrarDefaultDropDownOptions(dataTablePedimentos);
setShowCheckStatus(dataTablePedimentos, "pedimento", "seleccionado");
